<template>
  <div class="home">
    <div class="left">
      <img src="../image/home/logo.png" alt="" class="logo" />
      <img src="../image/home/phone.png" alt="" class="phone" />
    </div>
    <div class="right">
      <img src="../image/home/Haba.png" alt="" class="Haba" />
      <img src="../image/home/Gam.png" alt="" class="Gam" />

      <div class="download-app" @click="goApp">
        <img src="../image/home/app.png" alt="" />
        <div class="download-app-text">
          <div class="download-app-text-get">Get it on</div>
          <div class="download-app-text-app">App Store</div>
        </div>
      </div>
    </div>

    <div class="bom">
      <div @click="Terms">Terms of Service</div>
      <div @click="Privacy">Privacy Policy</div>
      <div @click="About">About Us</div>
      <div @click="Contact">Contact Us</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {};
  },
  methods: {
    Terms() {
      this.$router.push({ name: 'terms' });
    },
    Privacy() {
      this.$router.push({ name: 'privacy' });
    },
    About() {
      this.$router.push({ name: 'about' });
    },
    Contact() {
      this.$router.push({ name: 'contact' });
    },
    goApp() {
      window.location.href = 'https://apps.apple.com/us/app/haba/id6741684905';
    },
  },

  mounted() {
    const isMobile = /iPhone|iPad|iPod|Android|Windows Phone/i.test(
      navigator.userAgent
    );
    if (isMobile) {
      this.$router.push({ name: 'mobile' });
    } else {
      // PC端逻辑
    }
  },
};
</script>

<style scoped lang="scss">
.home {
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  background: url('../image/home/bag.png') no-repeat;
  background-size: cover;
  display: flex;
  overflow: hidden;
  position: relative;
  .left {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .logo {
      width: 7.625rem;
      height: 2.875rem;
      margin-left: 20%;
      margin-top: 5%;
    }
    .phone {
      width: 90%;
      height: 90%;
      margin-left: 11%;
    }
  }
  .right {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .Haba {
      width: 13rem;
      height: 3.2rem;
      margin-top: 30%;
      margin-bottom: 3%;
    }
    .Gam {
      width: 37rem;
      height: 3.5rem;
    }
  }
  .bom {
    display: flex;
    position: absolute;
    bottom: 4%;
    left: 50%;
    transform: translateX(-50%);
    color: #16b1b1;
    font-weight: bold;
    div {
      margin: 0 20px;
      user-select: none;
      -webkit-user-select: none; /* 兼容 Chrome 和 Safari */
      -moz-user-select: none; /* 兼容 Firefox */
      -ms-user-select: none; /* 兼容旧版 IE */
    }
  }
  .download-app {
    width: 150px;
    height: 40px;
    margin-top: 5%;
    border-radius: 60px;
    background: #000000;
    margin-right: 17px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 25px;
  cursor: pointer;
    img {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    .download-app-text {
      color: #ffffff;

      .download-app-text-get {
        font-size: 10px;
      }

      .download-app-text-app {
        font-size: 12px;
      }
    }
  }
}
</style>
